import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postDeleteManageableListItem = (id) => {
  return axiosClient
    .post(`api/admin/manageable-list/${id}/delete`, { id })
    .then((r) => r.data);
};
